module.exports = __webpack_public_path__ + "img/horizontal_7_3_5012.342f7f0f.png";